<!--
 * @Author: Vanny
 * @Date: 2018-10-15 15:04:28
 * @LastEditors: Vanny
 * @LastEditTime: 2019-12-10 17:35:00
 * @Description: 新手教程
 -->
<template>
  <div class="banner" v-if="slides && slides.length">
    <p class="title">{{ title }}</p>
    <gm-carousel :slides="slides" quotaClass="quota" class="slide" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import GmCarousel from '@/components/Carousel'

export default {
  props: {
    title: {
      type: String,
      default: '新手教程',
    },
  },
  computed: {
    ...mapGetters({
      slides: 'getBannerList',
    }),
  },
  components: {
    GmCarousel,
  },
}
</script>

<style lang="scss">
@import '../../../style/func.scss';

.banner {
  margin-bottom: px2rem(8px);
  padding-bottom: px2rem(20px);
  background-color: #fff;
  border-bottom: 1px solid #dddde0;

  .slide {
    height: px2rem(200px);
  }

  .title {
    margin: 0;
    padding: px2rem(8px) px2rem(12px);
  }

  .quota {
    height: px2rem(20px);
    bottom: px2rem(-20px);
    line-height: px2rem(20px);
    margin: 0;

    li {
      width: px2rem(8px);
      height: px2rem(8px);
      border: none;
      background: #e4e4e4;
      &.active {
        background: #4a90e2;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/help-center/components/Banner.vue